import { useNavigate } from "react-router-dom";
import { IoReturnUpBackOutline } from "react-icons/io5";
import CGUdata from "../data/conditionsGeneralUData";
import CGVdata from "../data/conditionsGeneralVData";
import "../style/ConditionsGeneral.css";

function ConditionsGeneral() {
    const navigate = useNavigate();
    return (
        <div className="main">
            <div className="main-content">
                        <IoReturnUpBackOutline
                        className="back-icon top"
                        onClick={() => navigate("/")}
                        />
                    <div className="center-elm">
                        <div className="header-section">
                            <h1 className="header-title marginB50 h1">Conditions Générales </h1>
                        </div>
                        <div className="main-Conditions-generales">
                            <div className="CGU">
                                <h2 className="h2 color center">
                                    Conditions Générales d'Utilisation (CGU)  
                                </h2>
                                <div className="faq-cards margit-top">
                                {
                                    CGUdata.map(condition => <div 
                                        key={condition.id}
                                        className="faq-card bg" 
                                    > 
                                            <h1 className="title">Article {condition.id} : {condition.title}</h1>
                                            <p className="description">{condition.description}</p>
                                        </div>
                                    )
                                }
                                </div>
                            </div>
                            <div className="CGU">
                                <h2 className="h2 color center">
                                    Conditions Générales de Vente (CGV)  
                                </h2>
                                <div className="faq-cards margit-top">
                                {
                                    CGVdata.map(condition => <div 
                                        key={condition.id}
                                        className="faq-card bg" 
                                    > 
                                            <h1 className="title">Article {condition.id} : {condition.title}</h1>
                                            <p className="description">{condition.description}</p>
                                        </div>
                                    )
                                }
                                </div>
                            </div>
                        </div>
                        <div className="div-explore">
                            <a href="https://jway.ma/" class="explore-btn-mention">Notre Site Web</a>
                        </div>
                    </div>
            </div>
        </div>
    );
}

export default ConditionsGeneral;